// set the logo width based on the payment icon, so they have the same length
function setEqualIconWidth() {
  const paymentIcon = $('.section-footer__payment-icons .section-footer__payment-icon');
  if (paymentIcon.length) {
    const paymentIconWidth = paymentIcon[0].width.baseVal.value;
    const logoIcon = $('.section-footer__logo-icons .logo__icon');
    
    if (logoIcon.length) {
      logoIcon?.width(paymentIconWidth); 
      paymentIcon?.width(paymentIconWidth); // the rendered payment icon width is different from the one showed by js, so we need to set it as well
    }
  }
};

setEqualIconWidth();